import { cloneVNode, Comment, Fragment, h, Text } from "vue";

// Обёртка над строками из слота customBody (CustomTable).
// Пока включён режим просмотра, клик по строке перехватывается на фазе погружения
// (до кнопок и ссылок внутри строки) и открывает панель со всеми полями этой строки.
// В обычном режиме строки отдаются как есть.
const decorate = (vnodes, listeners) =>
  vnodes.map((vnode) => {
    if (!vnode || vnode.type === Comment || vnode.type === Text) return vnode;
    if (vnode.type === Fragment) return h(Fragment, decorate(vnode.children || [], listeners));
    return cloneVNode(vnode, listeners);
  });

export default {
  name: "RowViewProxy",
  props: {
    active: Boolean,
    row: Object,
    onOpen: Function,
  },
  setup(props, { slots }) {
    return () => {
      const nodes = slots.default ? slots.default() : [];
      if (!props.active) return nodes;
      return decorate(nodes, {
        class: "row-view-target",
        onClickCapture: (e) => {
          e.stopPropagation();
          e.preventDefault();
          props.onOpen && props.onOpen(props.row, e.currentTarget);
        },
      });
    };
  },
};
